// Data types are structured as data.category.org.suffix in Hermes messages
export const CONNECTED_SITES_CATEGORY = 'connected_sites';
